module.exports = __webpack_public_path__ + "img/NFC_scan_complete.b306f0f5.png";